import './index.scss';
import React from 'react';

export default ({ text }) => {
    return (
        <div className="empty">
            <div className="img"></div>
            <div>
                <span>{text}</span>
            </div>
        </div>
    );
}